// Use the compiled bundle with the theme's Webpack 3 build.
import Choices from 'choices.js/public/assets/scripts/choices.js';

const instances = new WeakMap();

export const refreshShippingSelect = (select) => {
	const instance = instances.get(select);
	if (!instance) return;

	const value = select.value;
	instance.clearStore(false);
	select.value = value;
	instance.refresh();
};

const shippingSelect = () => {
	document.querySelectorAll('select.from_country, select.to_country, select.package_type, [data-search-results] select.goods_weight').forEach(select => {
		if (instances.has(select)) return;

		const isCountry = select.classList.contains('from_country') || select.classList.contains('to_country');
		const language = document.documentElement.lang.toLowerCase();
		const noResultsText = language.startsWith('sv') ? 'Inga resultat hittades' :
			(language.startsWith('de') ? 'Keine Ergebnisse gefunden' : 'No results found');
		const label = select.closest('.qq-form--element').querySelector('.qq-form--label');

		const instance = new Choices(select, {
			allowHTML: false,
			shouldSort: false,
			searchEnabled: isCountry || select.classList.contains('package_type'),
			searchFields: ['label'],
			searchResultLimit: -1,
			position: 'bottom',
			itemSelectText: '',
			noResultsText,
			noChoicesText: noResultsText,
			callbackOnCreateTemplates: function () {
				return {
					choice: (...args) => {
						const element = Choices.defaults.templates.choice.call(this, ...args);
						const option = args[1].element;
						if (isCountry && option && option.dataset.codeSrc) {
							const flag = document.createElement('img');
							flag.src = option.dataset.codeSrc;
							flag.alt = '';
							flag.width = 32;
							flag.height = 24;
							flag.className = 'shipping-select__flag';
							element.classList.add('shipping-select__country');
							element.insertBefore(flag, element.firstChild);
						}
						return element;
					},
				};
			},
		});

		if (label) {
			instance.containerOuter.element.setAttribute('aria-label', label.textContent.trim());
			instance.input.element.setAttribute('aria-label', label.textContent.trim());
		}
		if (isCountry) {
			// A visitor may have changed the native select before this bundle loaded.
			const option = select.options[select.selectedIndex];
			const flag = select.closest('.country-select').querySelector('.countryFlag img');
			if (flag && option && option.dataset.codeSrc) {
				flag.setAttribute('src', option.dataset.codeSrc);
			}
		}
		instances.set(select, instance);
	});
};

export default shippingSelect;



// WEBPACK FOOTER //
// ./scripts/modules/shippingSelect.js